/* eslint-disable */
export default {
  currentCall: '現在の通話',
  viewCalls: '通話の表示',
  view: '表示',
  incomingCall: '{numberOf}件の着信通話',
  incomingCalls: '{numberOf}件の着信通話',
  callOnHold: '{numberOf}件の保留中の通話',
  callsOnHold: '{numberOf}件の保留中の通話',
  otherDeviceCall: '{numberOf}の他のデバイスの通話',
  otherDeviceCalls: '{numberOf}件の他のデバイスの通話',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
